
































import { Prop, Vue, Watch } from 'vue-property-decorator'
import Component from 'vue-class-component'
import shipmentStore from '@/stores/ShipmentStore'
import ShipmentList from '@/components/shipment/ShipmentList.vue'
import ShipmentService from '@/services/ShipmentService'
import DictionariesService from '@/services/DictionariesService'
import ShipmentForm from '@/components/shipment/ShipmentForm.vue'
import CurrencyRatesPanel from '@/components/CurrencyRatesPanel.vue'
import layoutStore from '@/stores/LayoutStore'

@Component({
  components: { ShipmentForm, ShipmentList, CurrencyRatesPanel },
})
export default class DeliveriesPage extends Vue {
  @Prop(String)
  shipmentPointId: string | null

  layoutStore = layoutStore
  shipmentStore = shipmentStore
  showShipmentForm: boolean = false

  get isLoadedShipmentPoints() {
    return !!this.shipmentStore.pointsGroups
  }

  get currentCityName(): string {
    return this.shipmentStore.shipmentPoint
      ? this.shipmentStore.shipmentPoint.city.name
      : ''
  }

  created() {
    this.loadInitialData()

    const savedIsShowSidebar = localStorage.getItem('isShowLeftSidebar')

    if (savedIsShowSidebar !== null) {
      this.layoutStore.toggleLeftSidebar(JSON.parse(savedIsShowSidebar))
    }
  }

  toggleMiniMode(value: boolean) {
    this.layoutStore.toggleLeftSidebar(value)
  }

  loadInitialData() {
    ShipmentService.load().then(response => {
      DictionariesService.load(response)
      this.shipmentStore.loadShipmentPoints(response.pointsGroups)
    })
  }

  @Watch('shipmentPointId', { immediate: true })
  selectShipmentPoint(shipmentPointId: string) {
    this.shipmentStore.selectShipmentPoint(
      shipmentPointId ? parseInt(shipmentPointId) : null
    )
  }

  @Watch('layoutStore.isShowLeftSidebar')
  saveLocalSidebar(value: string) {
    localStorage.setItem('isShowLeftSidebar', value)
  }
}
